<template>
  <!-- 0: {Id: 4, Name: "观察记录表（学期）"}
1: {Id: 5, Name: "观察记录表（过程）"}
2: {Id: 6, Name: "图文记录"}
3: {Id: 7, Name: "运动记录"}
4: {Id: 8, Name: "体检记录"}
5: {Id: 9, Name: "视频记录"} -->
  <div class="configuration">
    <div class="importantTitle">{{ TypeText }}</div>
    <!-- 过程/学期记录表 -->
    <div class="" v-if="type == 4 || type == 5">
      <div class="secondaryTitle">
        <span></span> <span>{{ title }}</span>
        <!-- <img
          src="@/assets/edit.png"
          @click="addTitleDialogVisible = true"
          alt=""
        /> -->
      </div>
      <div class="itemBox" @click="selectBgDialogVisible = true">
        <div class="label">背景：</div>
        <div class="hintBtn">选择背景</div>
      </div>
      <div class="backCoverImg" v-if="addFrom.backCoverImg">
        <img src="@/assets/delete.png" class="delete" @click="delectBg" alt="" />
        <img class="image" :src="addFrom.backCoverImg" alt="" />
      </div>
      <div class="butList">
        <!-- <el-button
          size="mini"
          style="border-color: #5474e6; background: #5474e6"
          type="primary"
          >创建</el-button
        > -->
        <el-button size="mini" style="border-color: #5474e6; background: #5474e6; position: relative" type="primary">
          <input class="upload_file" id="file" @input="uploadFile" type="file" />
          批量导入</el-button>
        <el-button size="mini" style="border-color: #5474e6; background: #5474e6" type="primary"
          @click="onClickUploadFile">模板下载</el-button>
      </div>
      <!-- 表格 -->
      <div class="table">
        <div class="tableHeader row">
          <div class="lineOne cell">纬度</div>
          <div class="lineTwo cell">要素</div>
          <div class="lineThere cell">观察点</div>
          <div class="lineFour cell">操作</div>
        </div>
        <div class="row" v-for="(row, indexRow) in logSheet" :key="indexRow">
          <div class="lineOne cell border_right border_bottom">
            {{ row.Name }}
          </div>
          <div style="flex: 1">
            <div style="display: flex" v-for="(twoLine, twoLineIndex) in row.info" :key="twoLineIndex">
              <div class="cell border_bottom border_right lineTwo">
                {{ twoLine.Name }}
              </div>
              <div class="lineThere">
                <div class="cell" v-for="(ThereLine, ThereLineIndex) in twoLine.info" :key="ThereLineIndex">
                  <div style="flex: 1" class="border_bottom border_right textHiddent">
                    <el-popover placement="top-start" title="内容" width="200" trigger="hover" :content="ThereLine.Name">
                      <p slot="reference" style="margin: 0">
                        {{ ThereLine.Name }}
                      </p>
                    </el-popover>
                  </div>
                  <div class="lineFour border_bottom cell">
                    <el-button type="text" style="padding: 0" @click="
                      UpdateTenantTempDetailOneInfoByCycleWrite(ThereLine)
                    ">编辑</el-button>
                    <el-button type="text" @click="delectFn(ThereLine)" style="padding: 0; color: red">删除</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="" v-if="type == 12">
      <div class="secondaryTitle">
        <span></span> <span>{{ title }}</span>
      </div>
      <div class="itemBox" @click="selectBgDialogVisible = true">
        <div class="label">背景：</div>
        <div class="hintBtn">选择背景</div>
      </div>
      <div class="backCoverImg" v-if="addFrom.backCoverImg" style="margin-left: 10px">
        <img src="@/assets/delete.png" class="delete" @click="delectBg" alt="" />
        <img class="image" :src="addFrom.backCoverImg" alt="" />
      </div>
      <div class="butList">
        <el-button size="mini" style="border-color: #5474e6; background: #5474e6; position: relative" type="primary">
          <input class="upload_file" @input="tableUpload" type="file" />
          批量导入</el-button>
        <el-button size="mini" style="border-color: #5474e6; background: #5474e6" type="primary"
          @click="onClickTableDown">模板下载</el-button>
      </div>
      <!-- 表格 -->
      <el-table :data="growthQuestion" border style="width: 100%"
        :header-cell-style="{ background: '#DBF4FF', color: '#333' }">
        <el-table-column label="问题" align="center">
          <template slot-scope="scope">
            {{ scope.row.Name }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="danger" @click="delectFn(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 图文 -->
    <div class="" v-else-if="type == 6">
      <div class="itemBox">
        <div class="label">标题：</div>
        <div class="inputText">
          {{ title }}
        </div>
        <!-- <el-input v-model="title" style="width: 366px" size="mini"></el-input> -->
      </div>
      <div class="itemBox" @click="selectDialogVisible = true" v-if="isCanUpdatePlate">
        <div class="label">板式：</div>
        <div class="hintBtn">选择板式</div>
      </div>
      <div class="backCoverImg" v-if="PlateImageUrl">
        <img src="@/assets/delete.png" class="delete" @click="delectPlate" alt="" v-if="isCanUpdatePlate" />
        <img class="image" :src="PlateImageUrl" alt="" />
      </div>

      <div class="itemBox" @click="selectBgDialogVisible = true">
        <div class="label">背景：</div>

        <div class="hintBtn">选择背景</div>
      </div>
      <div class="backCoverImg" v-if="addFrom.backCoverImg">
        <img src="@/assets/delete.png" class="delete" @click="delectBg" alt="" />
        <img class="image" :src="addFrom.backCoverImg" alt="" />
      </div>
    </div>
    <!-- 运动记录表 -->
    <div v-else-if="type == 7">
      <div class="itemBox" @click="selectBgDialogVisible = true">
        <div class="label">背景：</div>
        <div class="hintBtn">选择背景</div>
      </div>
      <div class="backCoverImg" v-if="addFrom.backCoverImg">
        <img src="@/assets/delete.png" class="delete" @click="delectBg" alt="" />
        <img class="image" :src="addFrom.backCoverImg" alt="" />
      </div>
      <div class="exerciseItem" v-for="(item, index) in exerciseData" :key="index">
        <div>板块{{ toChinesNum(index + 1) }}：</div>
        <div class="inputBox">
          <div class="label" style="width: 70px">标题：</div>
          <el-input v-model="item.title" placeholder="请输入标题" style="width: 366px" size="mini"></el-input>
        </div>
        <div class="inputBox">
          <div class="label" style="width: 70px">图片：</div>
          <upload-self :value="item.imageArr[0].url" @Success="handleAvatarSuccess" :flag="index" />
        </div>
        <div class="inputBox">
          <div class="label" style="width: 70px">标准值：</div>
          <el-input v-model="item.standardValues" placeholder="请输入标准值" style="width: 366px" size="mini"></el-input>
        </div>
        <div class="inputBox">
          <div class="label" style="width: 70px">单位：</div>
          <el-input v-model="item.unit" placeholder="请输入单位" style="width: 366px" size="mini"></el-input>
        </div>
      </div>
    </div>
    <!-- 体检记录 -->
    <div v-else-if="type == 8">
      <div class="itemBox" @click="selectBgDialogVisible = true">
        <div class="label">背景：</div>
        <div class="hintBtn">选择背景</div>
      </div>
      <div class="backCoverImg" v-if="addFrom.backCoverImg">
        <img src="@/assets/delete.png" class="delete" @click="delectBg" alt="" />
        <img class="image" :src="addFrom.backCoverImg" alt="" />
      </div>
      <div class="MedicalSheetBox">
        <div class="MedicalSheetBoxHeader">
          <div>数据开关</div>
          <div>
            <span>一键开启/关闭</span>
            <el-switch v-model="allOPen" @change="allOPenChange"> </el-switch>
          </div>
        </div>
        <div class="MedicalSheetItem" v-for="(item, index) in MedicalSheet" :key="index">
          <div>
            {{ item.title }}
          </div>
          <div>
            <el-switch v-model="item.isOpen"> </el-switch>
          </div>
        </div>
      </div>
    </div>
    <!-- 视频记录 结语 -->
    <div v-else-if="type == 9 || type == 10">
      <div class="itemBox" @click="selectBgDialogVisible = true">
        <div class="label">背景：</div>
        <div class="hintBtn">选择背景</div>
      </div>
      <div class="backCoverImg" v-if="addFrom.backCoverImg">
        <img src="@/assets/delete.png" class="delete" @click="delectBg" alt="" />
        <img class="image" :src="addFrom.backCoverImg" alt="" />
      </div>
    </div>

    <div v-else-if="type == 13">
      <div class="itemBox" @click="selectBgDialogVisible = true">
        <div class="label">背景：</div>
        <div class="hintBtn">选择背景</div>
      </div>
      <div class="backCoverImg" v-if="addFrom.backCoverImg">
        <img src="@/assets/delete.png" class="delete" @click="delectBg" alt="" />
        <img class="image" :src="addFrom.backCoverImg" alt="" />
      </div>
    </div>
    <!-- 成长记录表11 -->
    <div v-else-if="type == 11">
      <div class="secondaryTitle">
        <span></span> <span>{{ title }}</span>
      </div>
      <div class="itemBox" @click="selectBgDialogVisible = true">
        <div class="label">背景：</div>
        <div class="hintBtn">选择背景</div>
      </div>
      <div class="backCoverImg" v-if="addFrom.backCoverImg">
        <img src="@/assets/delete.png" class="delete" @click="delectBg" alt="" />
        <img class="image" :src="addFrom.backCoverImg" alt="" />
      </div>
    </div>
    <div class="save">
      <!-- <el-button size="mini" @click="back()">返回</el-button> -->
      <el-button @click="addFn" size="mini" style="border-color: #5474e6; background: #5474e6"
        type="primary">保存</el-button>
    </div>

    <!-- 编辑名称 -->
    <el-dialog title="编辑名称" :visible.sync="addTitleDialogVisible" width="30%">
      <div>
        <el-input placeholder="请输入观察记录表名称" size="mini" v-model="name"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addTitleDialogVisible = false">取 消</el-button>
        <el-button type="primary" style="border-color: #5474e6; background: #5474e6"
          @click="addTitleDialogVisible = false">提 交</el-button>
      </span>
    </el-dialog>

    <!-- 创建编辑观察点 -->
    <el-dialog title="新增/编辑观察点" :visible.sync="addDialogVisible" width="30%">
      <div>
        <div class="inputBox">
          <div class="label">维度：</div>
          <el-select v-model="scopeValue" size="mini" placeholder="请选择">
            <el-option v-for="item in scopeList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="inputBox">
          <div class="label">要素：</div>
          <el-select v-model="scopeValue" size="mini" placeholder="请选择">
            <el-option v-for="item in scopeList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="inputBox">
          <div class="label">观察点：</div>
          <el-input v-model="name" type="textarea" :rows="4"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" style="border-color: #5474e6; background: #5474e6" @click="addDialogVisible = false">提
          交</el-button>
      </span>
    </el-dialog>

    <!-- 选择板式 -->
    <el-dialog title="选择板式" :visible.sync="selectDialogVisible" width="1180px">
      <div class="patternList">
        <div v-for="(item, index) in PlateList" :key="index" @click="selectPlate(item)">
          <img src="@/assets/check4.png" v-if="addFrom.plateId == item.Id" class="check4" alt="" />
          <img class="image" :src="item.Thumbnail" alt="" />
        </div>
      </div>
    </el-dialog>

    <!-- 选择背景 -->
    <el-dialog title="选择背景" :visible.sync="selectBgDialogVisible" width="610px">
      <div class="patternList">
        <div @click="CheckBg(item.Img)" style="width: 159px; height: 216px" v-for="(item, index) in bgList" :key="index">
          <img src="@/assets/check3.png" v-if="item.Img == addFrom.backCoverImg" class="check4" alt="" />
          <img class="image" :src="item.Thumbnail" alt="" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  SaveTenantTempDetailOneInfo,
  GetBackCoverImgList,
  GetPlateList,
  GetTenantTempDetailOneInfoByCycleWrite,
  GetTenantTempDetailOneInfoByImgTextRecord,
  ImportTenantTempDetailOneInfoByCycleWrite,
  FileUploadsExcel,
  UpdateTenantTempDetailOneInfoByCycleWrite,
  DeleteGrowTempQuestion,
  ImportGrowthQuestion,
  GetGrowthQuestionDetail,
} from "@/api/api";
import uploadSelf from "@/components/upload_self";
export default {
  components: {
    uploadSelf,
  },
  data() {
    return {
      info: null,
      title: "",
      type: "",
      TypeText: "",
      tempId: "",
      addFrom: {
        id: "",
        plateId: 0, //板式id
        backCoverImg: "", //背景图片
        content: "", //
      },
      bgImageUrl: "",
      PlateImageUrl: "",
      bgList: [], //背景数组
      PlateList: [], //板式数组
      name: "",
      addTitleDialogVisible: false,
      addDialogVisible: false,
      selectDialogVisible: false,
      selectBgDialogVisible: false,
      scopeValue: "",
      scopeList: [],
      isCanUpdatePlate: true, //是否可以修改板式
      // 运动模块参数
      exerciseData: [
        {
          title: "",
          imageArr: [
            {
              url: "",
              type: "img",
            },
          ],
          standardValues: "",
          unit: "",
        },
        {
          title: "",
          imageArr: [
            {
              url: "",
              type: "img",
            },
          ],
          standardValues: "",
          unit: "",
        },
        {
          title: "",
          imageArr: [
            {
              url: "",
              type: "img",
            },
          ],
          standardValues: "",
          unit: "",
        },
      ],
      // 记录表模块参数
      logSheet: [
        // {
        //   Name: "",
        //   info: [
        //     {
        //       Id: 0,
        //       Name: "",
        //       info: [],
        //     },
        //   ],
        // },
      ],
      allOPen: true,
      // 体检记录表
      MedicalSheet: [
        {
          title: "身高",
          isOpen: true,
          type: 1,
          topicType: "input",
          unit: "CM",
        },
        {
          title: "体重",
          isOpen: true,
          type: 2,
          topicType: "input",
          unit: "KG",
        },
        {
          title: "视力（左+右）",
          isOpen: true,
          type: 3,
          child: [
            {
              title: "视力左",
              isOpen: true,
              type: 3,
              topicType: "input",
              unit: "",
            },
            {
              title: "视力右",
              isOpen: true,
              type: 3,
              topicType: "input",
              unit: "",
            },
          ],
          topicType: "child",
        },
        {
          title: "听力（左+右）",
          isOpen: true,
          type: 4,
          topicType: "child",
          child: [
            {
              title: "听力左",
              isOpen: true,
              type: 3,
              topicType: "radio",
              rightAnswers: "1",
              unit: "",
              answerList: [
                {
                  title: "正常",
                  value: "1",
                },
                {
                  title: "异常",
                  value: "0",
                },
              ],
            },
            {
              title: "听力右",
              isOpen: true,
              type: 3,
              topicType: "radio",
              rightAnswers: "1",
              unit: "",
              answerList: [
                {
                  title: "正常",
                  value: "1",
                },
                {
                  title: "异常",
                  value: "0",
                },
              ],
            },
          ],
        },
        {
          title: "龋齿",
          isOpen: true,
          type: 5,
          topicType: "input",
          unit: "颗",
        },
        {
          title: "血色素",
          isOpen: true,
          type: 6,
          topicType: "input",
          unit: "g/L",
        },
      ],
      growthQuestion: [],
    };
  },
  created() {
    let info = JSON.parse(unescape(this.$route.query.info));
    this.info = info;

    this.title = info.title;
    this.type = info.type;
    this.addFrom.id = info.id;
    this.TypeText = info.TypeText;
    this.tempId = info.tempId;
    console.log("info", info);
    this.GetBackCoverImgList();
    if (this.type == 6) {
      this.GetPlateList();
    } else if (this.type == 4 || this.type == 5) {
      this.GetTenantTempDetailOneInfoByImgTextRecord();
      this.GetTenantTempDetailOneInfoByCycleWrite();
    } else if (this.type == 12) {
      this.GetGrowthQuestionDetail();
      this.GetTenantTempDetailOneInfoByImgTextRecord();
    } else {
      this.GetTenantTempDetailOneInfoByImgTextRecord();
    }
  },
  methods: {
    onClickUploadFile() {
      window.open(
        "http://www.mushroomisland.cn/exceldown/成长足迹记录表导入模板.xlsx"
      );
    },
    allOPenChange() {
      this.MedicalSheet.forEach((item) => {
        item.isOpen = this.allOPen;
      });
    },
    back() {
      this.$router.back();
    },
    delectFn(item) {
      const h = this.$createElement;
      let that = this;
      this.$msgbox({
        title: "操作提示",
        message: h("p", null, [
          h("span", null, "是否确认"),
          h("i", { style: "color: red" }, "删除？"),
        ]),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: async (action, instance, done) => {
          if (action === "confirm") {
            let xhr = await DeleteGrowTempQuestion({
              id: item.Id,
            });
            if (xhr.data.success) {
              that.$message.success("删除成功");
              this.GetTenantTempDetailOneInfoByCycleWrite();
              this.GetGrowthQuestionDetail();
            } else {
              that.$message.error(xhr.data.msg);
            }
          }
          done();
        },
      });
    },
    UpdateTenantTempDetailOneInfoByCycleWrite(item) {
      this.$prompt("修改", {
        confirmButtonText: "确认修改",
        cancelButtonText: "取消",
        inputType: "textarea",
        inputValue: item.Name,
      }).then(async (res) => {
        if (res.action == "confirm" && res.value) {
          let xhr = await UpdateTenantTempDetailOneInfoByCycleWrite({
            id: item.Id,
            title: res.value,
          });
          if (xhr.data.success) {
            this.$message.success("修改成功");
            this.GetTenantTempDetailOneInfoByCycleWrite();
          } else {
            this.$message.error(xhr.data.msg);
          }
        }
      });
    },
    uploadFile(item) {
      //console.log(item);
      const fileObj = item.target.files[0];
      // FormData 对象
      const form = new FormData();
      // 文件对象
      form.append("file", fileObj);
      form.append("filetype", "excel");
      FileUploadsExcel(form).then((response) => {
        // this.excelurl = response.data.url;
        let file = document.getElementById("file");
        file.value = ""; //file的value值只能设置为空字符串
        this.ImportTenantTempDetailOneInfoByCycleWrite(response.data.response);
        // this.$message.info("文件：" + fileObj.name + "上传成功");
      });
    },
    // 模板下载
    onClickTableDown() {
      window.open(
        "http://www.mushroomisland.cn/exceldown/成长记录表2导入模板.xlsx"
      );
    },
    // 表格2获取
    async GetGrowthQuestionDetail() {
      let res = await GetGrowthQuestionDetail({ Id: this.addFrom.id });
      if (res.data.success) {
        this.growthQuestion = res.data.response;
      } else {
        this.growthQuestion = [];
      }
    },
    // 表格2 过程导入
    tableUpload(item) {
      const fileObj = item.target.files[0];
      // FormData 对象
      const form = new FormData();
      // 文件对象
      form.append("file", fileObj);
      form.append("filetype", "excel");
      FileUploadsExcel(form).then((response) => {
        // this.excelurl = response.data.url;
        this.ImportGrowthQuestion(response.data.response);
        // this.$message.info("文件：" + fileObj.name + "上传成功");
      });
    },
    // 表格2导入确定
    async ImportGrowthQuestion(fileName) {
      let xhr = await ImportGrowthQuestion({
        tempId: this.tempId, //主模块id
        tempDetailId: this.addFrom.id, //子模块id
        fileName: fileName, // 文件路径
      });
      if (xhr.data.success) {
        this.GetGrowthQuestionDetail();
      } else {
        this.$message.warning(xhr.data.msg);
      }
    },
    async ImportTenantTempDetailOneInfoByCycleWrite(fileName) {
      let xhr = await ImportTenantTempDetailOneInfoByCycleWrite({
        tempId: this.tempId, //主模块id
        tempDetailId: this.addFrom.id, //子模块id
        fileName: fileName, // 文件路径
      });
      if (xhr.data.success) {
        this.GetTenantTempDetailOneInfoByCycleWrite();
      } else {
        this.$message({
          type: "warning",
          message: res.data.msg,
        });
      }
    },
    // 获取图文详情
    async GetTenantTempDetailOneInfoByImgTextRecord() {
      let xhr = await GetTenantTempDetailOneInfoByImgTextRecord({
        id: this.addFrom.id,
      });
      if (xhr.data.success) {
        this.addFrom.backCoverImg = xhr.data.response.BackCoverImg;
        this.addFrom.plateId = xhr.data.response.PlateId;
        if (this.type == 7 && xhr.data.response.Content) {
          this.exerciseData = JSON.parse(xhr.data.response.Content);
        } else if (this.type == 8 && xhr.data.response.Content) {
          this.MedicalSheet = JSON.parse(xhr.data.response.Content);
        }

        if (this.addFrom.plateId) {
          this.addFrom.plateId = xhr.data.response.PlateId;
          let PlateImage = this.PlateList.find((item) => {
            return item.Id == this.addFrom.plateId;
          });
          //console.log(PlateImage, "PlateImagePlateImagePlateImage");
          if (PlateImage) {
            this.PlateImageUrl = PlateImage.Thumbnail;
            if (this.info.status != 2)
              this.isCanUpdatePlate = false;
            else
              this.isCanUpdatePlate = true;
          } else {
            this.isCanUpdatePlate = true;
          }
        } else {
          this.isCanUpdatePlate = true;
        }
      }
    },
    // 获取记录表列表
    async GetTenantTempDetailOneInfoByCycleWrite() {
      let xhr = await GetTenantTempDetailOneInfoByCycleWrite({
        id: this.addFrom.id,
      });
      if (xhr.data.success) {
        this.logSheet = xhr.data.response;
      }
    },
    selectPlate(item) {
      this.addFrom.plateId = item.Id;
      this.PlateImageUrl = item.Thumbnail;
      this.selectDialogVisible = false;
    },
    delectPlate() {
      this.addFrom.plateId = "";
      this.PlateImageUrl = "";
    },
    delectBg() {
      this.addFrom.backCoverImg = "";
    },
    CheckBg(image) {
      this.addFrom.backCoverImg = image;
      this.selectBgDialogVisible = false;
    },
    // 获取背景列表
    async GetBackCoverImgList() {
      let xhr = await GetBackCoverImgList();
      if (xhr.data.success) {
        this.bgList = xhr.data.response;
      } else {
        this.bgList = [];
      }
    },
    // 获取板式列表
    async GetPlateList() {
      let xhr = await GetPlateList();
      if (xhr.data.success) {
        this.PlateList = xhr.data.response;
        this.GetTenantTempDetailOneInfoByImgTextRecord();
      } else {
        this.PlateList = [];
      }
    },
    async addFn() {
      if (!this.addFrom.backCoverImg) {
        this.$message.warning("请选择背景");
        return;
      }
      if (this.type == 6) {
        //图文记录表
        if (!this.addFrom.plateId) {
          this.$message.warning("请选择板式");
          return;
        }
      }
      if (this.type == 7) {
        for (let index = 0; index < this.exerciseData.length; index++) {
          const element = this.exerciseData[index];
          if (!element.title) {
            this.$message.warning(`请填写板块${index + 1}的标题`);
            return;
          }
          if (!element.standardValues) {
            this.$message.warning(`请填写板块${index + 1}的标准值`);
            return;
          }
          if (!element.unit) {
            this.$message.warning(`请填写板块${index + 1}的单位`);
            return;
          }
          if (!element.imageArr) {
            this.$message.warning(`请上传板块${index + 1}的图片`);
            return;
          } else {
            for (let index = 0; index < element.imageArr.length; index++) {
              const elementImg = element.imageArr[index];
              if (!elementImg.url) {
                this.$message.warning(`请上传板块${index + 1}的图片`);
                return;
              }
            }
          }
        }

        this.addFrom.content = JSON.stringify(this.exerciseData);
      }
      if (this.type == 8) {
        this.addFrom.content = JSON.stringify(this.MedicalSheet);
      }

      let xhr = await SaveTenantTempDetailOneInfo(this.addFrom);
      if (xhr.data.success) {
        this.$message.success("保存成功");
        this.$router.back();
      } else {
        this.$message.error(xhr.data.msg);
      }
    },
    handleAvatarSuccess(res, index) {
      this.exerciseData[index].imageArr[0].url = res.response;
    },
    toChinesNum(num) {
      let changeNum = [
        "零",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
      ];
      let unit = ["", "十", "百", "千", "万"];
      num = parseInt(num);
      let getWan = (temp) => {
        let strArr = temp.toString().split("").reverse();
        let newNum = "";
        for (var i = 0; i < strArr.length; i++) {
          newNum =
            (i == 0 && strArr[i] == 0
              ? ""
              : i > 0 && strArr[i] == 0 && strArr[i - 1] == 0
                ? ""
                : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i])) +
            newNum;
        }
        return newNum;
      };
      let overWan = Math.floor(num / 10000);
      let noWan = num % 10000;
      if (noWan.toString().length < 4) {
        noWan = "0" + noWan;
      }
      return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
    },
  },
};
</script>

<style lang="less" scoped>
.inputBox {
  display: flex;
  margin-bottom: 28px;

  .label {
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    line-height: 22px;
    width: 100px;
    text-align: right;
  }
}

.MedicalSheetBox {
  margin-top: 10px;
  width: 705px;
  min-height: 397px;
  border: 1px solid #ededed;
  padding: 23px;
  box-sizing: border-box;

  .MedicalSheetItem {
    display: flex;
    width: 400px;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 26px;

    div:ntn-child(1) {
      font-size: 16px;
      font-weight: 500;
      color: #333333;
    }
  }

  .MedicalSheetBoxHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 400px;
    padding-bottom: 58px;

    div:ntn-child(1) {
      font-size: 16px;
      font-weight: 500;
      color: #333333;
    }

    div:nth-child(2) {
      font-size: 14px;
      font-weight: 500;
      color: #4083fe;
      line-height: 20px;

      span {
        padding-right: 5px;
      }
    }
  }
}

// 表格
.table {
  .textHiddent {
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    line-height: 44px;
    -webkit-box-orient: vertical;
    padding: 0 10px;
    height: 44px;
    cursor: pointer;
    box-sizing: border-box;
  }

  .row {
    display: flex;
  }

  .tableHeader {
    background: #f2f5ff;
    line-height: 44px;
  }

  .cell {
    box-sizing: border-box;
    text-align: center;
    width: 100%;
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .border_bottom {
    border-bottom: solid 1px #ededed;
  }

  .border_top {
    border-top: solid 1px #ededed;
  }

  .border_left {
    border-left: solid 1px #ededed;
  }

  .border_right {
    border-right: solid 1px #ededed;
  }

  .lineOne {
    width: 236px;
  }

  .lineTwo {
    width: 338px;
    display: flex;
  }

  .lineThere {
    flex: 1;
  }

  .lineFour {
    width: 200px;
    // flex: 1;
  }
}

.upload_file {
  position: absolute;
  width: 80px;
  height: 28px;
  top: 0;
  left: 0;
  opacity: 0;
}

.backCoverImg {
  width: 100px;
  height: 136px;
  position: relative;
  margin-left: 50px;

  .image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .delete {
    width: 20px;
    height: auto;
    position: absolute;
    top: 3px;
    right: 3px;
  }
}

.exerciseItem {
  width: 568px;
  height: 346px;
  border: 1px solid #ededed;
  padding: 9px 24px;
  box-sizing: border-box;
  margin-top: 25px;
}

.exerciseItem>div:nth-child(1) {
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  line-height: 22px;
  padding-bottom: 23px;
}

/deep/.el-dialog {
  border-radius: 10px;
  overflow: hidden;
}

/deep/.el-dialog__header {
  background: #f2f5ff;
}

.patternList {
  display: flex;
  flex-wrap: wrap;

  div {
    width: 159px;
    height: 216px;
    background: #fafbff;
    border: 1px solid #979797;
    margin: 14px;
    cursor: pointer;
    position: relative;

    .check4 {
      width: 16px;
      height: 16px;
      top: 8px;
      right: 8px;
      position: absolute;
      object-fit: contain;
    }

    .image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.itemBox {
  display: flex;
  margin: 21px 0;
  align-items: center;

  .label {
    font-size: 14px;
    font-weight: 500;
    color: #333333;
    line-height: 22px;
    width: 50px;
    text-align: right;
  }

  .hintBtn {
    font-size: 14px;
    font-weight: 500;
    color: #4083fe;
    line-height: 20px;
    cursor: pointer;
  }
}

.inputBox {
  display: flex;
  margin-bottom: 28px;

  .label {
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    line-height: 22px;
    width: 100px;
    text-align: right;
  }

  .inputText {
    font-weight: 500;
    color: #333333;
    line-height: 22px;
    text-align: right;
  }
}

.configuration {
  background-color: #fff;
  min-height: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  padding-bottom: 30px;

  .butList {
    margin-bottom: 37px;
    margin-top: 10px;
  }

  .save {
    display: flex;
    justify-content: flex-end;
    padding-top: 30px;
  }

  .importantTitle {
    text-align: center;
    font-size: 20px;
    font-weight: 500;
    color: #333333;
    line-height: 28px;
    padding-top: 19px;
    padding-bottom: 10px;
  }

  .secondaryTitle {
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    line-height: 22px;
    padding-bottom: 20px;

    img {
      width: 15px;
      height: auto;
      margin-left: 12px;
      transform: translateY(3px);
    }
  }
}
</style>